import { render } from "./FormattedNumber.vue?vue&type=template&id=3baca3df&ts=true"
import script from "./FormattedNumber.vue?vue&type=script&lang=ts"
export * from "./FormattedNumber.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__